module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Typography ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-font-size"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-font-weight"
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-line-height"
    }
  }), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดความหนาของ Line Height\n      ")]), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-text-align"
    }
  }), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดความหนาของ Alignment ของ Inline Content ด้านใน Container\n      ")]), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-text-transform"
    }
  }), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้กำหนด Text Transform ให้กับ Text ของ Element\n      ")]), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-letter-spacing"
    }
  }), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดระยะห่างระหว่างตัวอักษร\n      ")]), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-white-space"
    }
  }), _vm._v(" "), _vm._m(70), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดการจัดการกับ White Space\n      ")]), _vm._v(" "), _vm._m(71), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicPadding'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Padding\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicZIndex'
      }
    }
  }, [_vm._v("\n            Z Index   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-typography"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Typography\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-font-size"
    }
  }, [_vm._v("Font Size")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-font-weight"
    }
  }, [_vm._v("Font Weight")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-line-height"
    }
  }, [_vm._v("Line Height")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-text-align"
    }
  }, [_vm._v("Text Align")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-text-transform"
    }
  }, [_vm._v("Text Transform")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-letter-spacing"
    }
  }, [_vm._v("Letter Spacing")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-white-space"
    }
  }, [_vm._v("White Space")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-font-size"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Font Size\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดขนาดของ Font Size โดย Value จะเป็นค่าระดับขนาดของ Font ตั้งแต่\n        "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1")]), _vm._v(" ถึง "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fs-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("font-size")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Value")]), _vm._v(" "), _c('th', [_vm._v("ขนาดของ Font")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("3rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2.5rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1.5rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("5")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1.125rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("6")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("7")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0.85rem")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8")])]), _vm._v(" "), _c('td', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("0.7rem")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Font Size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Font Size -->\n<p class=\"_fs-1\">Hello World</p>\n<p class=\"_fs-2\">Hello World</p>\n<p class=\"_fs-3\">Hello World</p>\n<p class=\"_fs-4\">Hello World</p>\n<p class=\"_fs-5\">Hello World</p>\n<p class=\"_fs-6\">Hello World</p>\n<p class=\"_fs-7\">Hello World</p>\n<p class=\"_fs-8\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_fs-1"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-2"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-3"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-4"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-5"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-6"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-7"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fs-8"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-font-weight"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Font Weight\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้สำหรับกำหนดความหนาของ Font โดย Value จะเป็นค่าที่กำหนดใน "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("font-weight")]), _vm._v(" ระดับตั้งแต่\n        "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("100")]), _vm._v(" ถึง "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("900")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fw-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("font-weight")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_fw-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("100")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("200")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("300")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("400")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("500")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("600")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("700")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("800")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("900")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Font Weight")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Font Weight -->\n<p class=\"_fw-100\">Hello World</p>\n<p class=\"_fw-200\">Hello World</p>\n<p class=\"_fw-300\">Hello World</p>\n<p class=\"_fw-400\">Hello World</p>\n<p class=\"_fw-500\">Hello World</p>\n<p class=\"_fw-600\">Hello World</p>\n<p class=\"_fw-700\">Hello World</p>\n<p class=\"_fw-800\">Hello World</p>\n<p class=\"_fw-900\">Hello World</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_fw-100"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-200"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-300"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-400"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-500"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-600"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-700"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-800"
  }, [_vm._v("Hello World")]), _vm._v(" "), _c('p', {
    staticClass: "_fw-900"
  }, [_vm._v("Hello World")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-line-height"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Line Height\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_lh-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("line-height")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_lh-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Percentage Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("100pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("125pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("150pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("175pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("200pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("225pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("250pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("275pct")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("300pct")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Line Height")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Line Height -->\n<p class=\"_lh-100pct\">._lh-100pct</p>\n<p class=\"_lh-125pct\">._lh-125pct</p>\n<p class=\"_lh-150pct\">._lh-150pct</p>\n<p class=\"_lh-175pct\">._lh-175pct</p>\n<p class=\"_lh-200pct\">._lh-200pct</p>\n<p class=\"_lh-225pct\">._lh-225pct</p>\n<p class=\"_lh-250pct\">._lh-250pct</p>\n<p class=\"_lh-275pct\">._lh-275pct</p>\n<p class=\"_lh-300pct\">._lh-300pct</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_lh-100pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-100pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-125pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-125pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-150pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-150pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-175pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-175pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-200pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-200pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-225pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-225pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-250pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-250pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-275pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-275pct")]), _vm._v(" "), _c('p', {
    staticClass: "_lh-300pct _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _mgbt-8px _bgcl-white"
  }, [_vm._v("._lh-300pct")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-text-align"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Text Align\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_tal-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("text-align")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_tal-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("l")]), _vm._v(" สำหรับ \"left\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"right\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ct")]), _vm._v(" สำหรับ \"center\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("jtf")]), _vm._v(" สำหรับ \"justify\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Text Align")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Text Align -->\n<p class=\"_tal-l\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  Pellentesque sit amet vel velit finibus ullamcorper.\n  Aenean in tellus vel nibh imperdiet semper eget eu turpis\n</p>\n<p class=\"_tal-r\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  Pellentesque sit amet vel velit finibus ullamcorper.\n  Aenean in tellus vel nibh imperdiet semper eget eu turpis\n</p>\n<p class=\"_tal-ct\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  Pellentesque sit amet vel velit finibus ullamcorper.\n  Aenean in tellus vel nibh imperdiet semper eget eu turpis\n</p>\n<p class=\"_tal-jtf\">\n  Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n  Pellentesque sit amet vel velit finibus ullamcorper.\n  Aenean in tellus vel nibh imperdiet semper eget eu turpis\n</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_tal-l _mgbt-8px _bdw-2px _bdcl-neutral-500 _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Pellentesque sit amet vel velit finibus ullamcorper.\n          Aenean in tellus vel nibh imperdiet semper eget eu turpis\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-r _mgbt-8px _bdw-2px _bdcl-neutral-500 _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Pellentesque sit amet vel velit finibus ullamcorper.\n          Aenean in tellus vel nibh imperdiet semper eget eu turpis\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-ct _mgbt-8px _bdw-2px _bdcl-neutral-500 _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Pellentesque sit amet vel velit finibus ullamcorper.\n          Aenean in tellus vel nibh imperdiet semper eget eu turpis\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-jtf _bd-1px _bdw-2px _bdcl-neutral-500 _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Pellentesque sit amet vel velit finibus ullamcorper.\n          Aenean in tellus vel nibh imperdiet semper eget eu turpis\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-text-transform"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Text Transform\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ttf-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("text-transform")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ttf-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("cptl")]), _vm._v(" สำหรับ \"capitalize\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("lwc")]), _vm._v(" สำหรับ \"lowercase\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("upc")]), _vm._v(" สำหรับ \"uppercase\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("n")]), _vm._v(" สำหรับ \"none\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Text Transform")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<p class=\"_ttf-n\">hello world</p>\n<p class=\"_ttf-cptl\">hello world</p>\n<p class=\"_ttf-upc\">hello world</p>\n<p class=\"_ttf-lwc\">hello world</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_ttf-n"
  }, [_vm._v("hello world")]), _vm._v(" "), _c('p', {
    staticClass: "_ttf-cptl"
  }, [_vm._v("hello world")]), _vm._v(" "), _c('p', {
    staticClass: "_ttf-upc"
  }, [_vm._v("hello world")]), _vm._v(" "), _c('p', {
    staticClass: "_ttf-lwc"
  }, [_vm._v("hello world")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-letter-spacing"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Letter Spacing\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ltspc-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("letter-spacing")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-14px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ltspc-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Pixel Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("1px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("2px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("4px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("8px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("16px")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("32px")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Letter Spacing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Line Height -->\n<p class=\"_ltspc-1px\">Meowwloo</p>\n<p class=\"_ltspc-2px\">Meowwloo</p>\n<p class=\"_ltspc-4px\">Meowwloo</p>\n<p class=\"_ltspc-8px\">Meowwloo</p>\n<p class=\"_ltspc-16px\">Meowwloo</p>\n<p class=\"_ltspc-32px\">Meowwloo</p>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('p', {
    staticClass: "_ltspc-1px _mgbt-8px"
  }, [_vm._v("Meowwloo")]), _vm._v(" "), _c('p', {
    staticClass: "_ltspc-2px _mgbt-8px"
  }, [_vm._v("Meowwloo")]), _vm._v(" "), _c('p', {
    staticClass: "_ltspc-4px _mgbt-8px"
  }, [_vm._v("Meowwloo")]), _vm._v(" "), _c('p', {
    staticClass: "_ltspc-8px _mgbt-8px"
  }, [_vm._v("Meowwloo")]), _vm._v(" "), _c('p', {
    staticClass: "_ltspc-16px _mgbt-8px"
  }, [_vm._v("Meowwloo")]), _vm._v(" "), _c('p', {
    staticClass: "_ltspc-32px"
  }, [_vm._v("Meowwloo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-white-space"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" White Space\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_ws-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("white-space")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_wsp-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("nm")]), _vm._v(" สำหรับ \"normal\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("nw")]), _vm._v(" สำหรับ \"no-wrap\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("p")]), _vm._v(" สำหรับ \"pre\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("pl")]), _vm._v(" สำหรับ \"pre-line\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("pw")]), _vm._v(" สำหรับ \"pre-wrap\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน White Space")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- White Space -->\n<div class=\"_wsp-nm\">   A B C D E F</div>\n<div class=\"_wsp-nw\">   A B C D E F</div>\n<div class=\"_wsp-p\">   A B C D E F</div>\n<div class=\"_wsp-pl\">   A B C D E F</div>\n<div class=\"_wsp-pw\">   A B C D E F</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_wsp-nm _w-64px _bdw-2px _bdcl-neutral-500 _h-64px _mgbt-8px _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("   A B C D E F")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-nw _w-64px _bdw-2px _bdcl-neutral-500 _h-64px _mgbt-8px _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("   A B C D E F")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-p _w-64px _bdw-2px _bdcl-neutral-500 _h-64px _mgbt-8px _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("   A B C D E F")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-pl _w-64px _bdw-2px _bdcl-neutral-500 _h-64px _mgbt-8px _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("   A B C D E F")]), _vm._v(" "), _c('div', {
    staticClass: "_wsp-pw _w-64px _bdw-2px _bdcl-neutral-500 _h-64px _mgbt-8px _bd-1px _bdcl-neutral-400 _bgcl-white"
  }, [_vm._v("   A B C D E F")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d0e2e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicTypography.vue
// module id = 121
// module chunks = 0